import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    FilterUpdateInput,
    UpdateFilter as UpdateFilterMutation,
    UpdateFilterVariables as UpdateFilterMutationVariables,
} from 'nutshell-graphql-types';

import PROSPECTOR_SAVED_FILTER_FRAGMENT from '../fragments/prospector-saved-filter-fragment.graphql';
import UPDATE_FILTER from '../mutations/update-saved-filter.graphql';

export function useUpdateFilter(): {
    updateFilter: (arg1: FilterUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updateFilter, {loading, error}] = useMutation<
        UpdateFilterMutation,
        UpdateFilterMutationVariables
    >(UPDATE_FILTER);

    return {
        updateFilter: (input: FilterUpdateInput) =>
            updateFilter({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const updatedFilter =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.filterUpdate &&
                        mutationResults.data.filterUpdate.filter;

                    if (!updatedFilter) return;

                    proxy.writeFragment({
                        id: input.id,
                        fragment: PROSPECTOR_SAVED_FILTER_FRAGMENT,
                        fragmentName: 'ProspectorSavedFilterFragment',
                        data: {
                            ...updatedFilter,
                        },
                    });
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
